import { useEffect, useState } from "react";
import { Box } from "@mui/material";

/**
 * AuthFormWrapper
 * Constrains the form width and adds consistent vertical spacing.
 * Used inside AuthShell's content area.
 */
const AuthFormWrapper = ({ children, maxWidth = 340 }) => {

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "300px",
        height: "100%",          //  take full available height
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        overflow: "hidden",     // prevent outer overflow
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent:"center",
          alignItems: "center",
          overflowY: "auto",
          maxHeight: "100%",
          // Hide scrollbar (all browsers)
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AuthFormWrapper;
